import React, { useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Featured from './components/Featured';
import ProjectsGrid from './components/ProjectsGrid';
import ProjectModal from './components/ProjectModal';
import Courses from './components/Courses';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

const App = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
  };

  const handleCloseModal = () => {
    setSelectedProject(null);
  };

  const handleNavigateProject = (project) => {
    setSelectedProject(project);
  };

  return (
    <div className="min-h-screen bg-page text-gray-100">
      <Navigation />
      <Hero />
      <Featured onProjectClick={handleProjectClick} />
      <ProjectsGrid onProjectClick={handleProjectClick} />
      <Courses />
      <AboutSection />
      <Footer />
      <ProjectModal
        project={selectedProject}
        onClose={handleCloseModal}
        onNavigate={handleNavigateProject}
      />
      <Analytics />
    </div>
  );
};

export default App;
